
class IllegalArgumentError extends Error {
}

export default IllegalArgumentError;
